<template>
  <div>


    <!-- share popup -->
  
      <span v-if="selectedUsers.length != 0">
        <h6 class="mb-2">Users</h6>
        <div class="flex flex-wrap mb-4">
          <div
            class="text-center mr-1"
            v-for="(selectedUser, index16) in selectedUsers"
            :key="index16"
          >
            <div class="selected-names">
              <img
                v-if="selectedUser.picture != ''"
                class="person-img rounded-full shadow-md block"
                :src="selectedUser.picture"
              />
              <img
                v-else
                class="person-img rounded-full shadow-md block"
                src="@/assets/images/pages/user-circle-solid.svg"
              />
              <span @click="closeSelectedUser(index16)" class="close"
                >&times;</span
              >
            </div>
            <p class="name-selected">
              {{ selectedUser.first_name }} {{ selectedUser.last_name }}
            </p>
          </div>
        </div>
      </span>
          <vs-table class="removeCheckbox" multiple v-model="selectedUsers" :data="userList">
             <template slot="thead">
              <vs-th>Select all</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].picture">
                  <img
                    v-if="data[indextr].picture != ''"
                    class="person-img rounded-full shadow-md block"
                    :src="data[indextr].picture"
                  />
                  <img
                    v-else
                    class="person-img rounded-full shadow-md block"
                    src="@/assets/images/pages/user-circle-solid.svg"
                  />
                </vs-td>
                <vs-td>
                  <span>
                    {{ data[indextr].first_name }} {{ data[indextr].last_name }}
                  </span>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <div class="flex flex-wrap justify-between items-center my-4">
            <div>
              <vs-button
                v-if="currentPageUser > 1"
                @click="showBackUser"
                color="primary"
                icon-pack="feather"
                icon="icon-chevron-left"
              ></vs-button>
            </div>
            <div class="text-right">
              <vs-button
                icon-pack="feather"
                icon="icon-chevron-right"
                v-if="userList.length == 20 && showButtonUser == true"
                @click="showMoreUser"
                ></vs-button
              >
            </div>
          </div>   
  </div>
</template>


<script>
import { blog } from '../post-blogs/mixins/blog.js'
import {
  user_list
} from '@/api/user'
import {
  fetchUserClint
} from '@/api/blog-post.js'
export default {
  name: 'Blogs-Post',
  mixins: [blog],
  
  mounted () {


    fetchUserClint(
      localStorage.getItem('customer_id'),
      'User',
      this.query_page_user
    )
      .then((res) => {
        
        this.userList = res.data.data.users_list
        this.userListForAdd = res.data.data.users_list
        this.showButtonUser = res.data.data.meta.has_next
      })
      .catch((e) => {
        
      })
      
    this.user = JSON.parse(localStorage.getItem('userInfo'))
    this.customerName = this.user.first_name
    this.userPicture = this.user.picture
   
  },
  methods:{
    // async fetch_list (query, params = null) {
    //   // const userInfo = JSON.parse(localStorage.getItem('userInfo'))
    //   const userId = this.$store.state.LoginStorage.user_details.customer_id
    //   try {
    //     let text = ''
    //     if (params == null) {
    //       text = 'Fetching User List ...'
    //     } else {
    //       text = 'Fetching User List ...'
    //     }
    //     this.$vs.loading({
    //       text
    //     })
    //     const { data } = await user_list(userId, query, params)
    //     
    //     this.meta = data.data.met

    //   } catch (e) {
    //     
    //   } finally {
    //     this.$vs.loading.close()
    //   }
    // },
  }
  
}
</script>

<style>
.width-66 {
  width: 66.67%;
}
.border-top {
  border-top: 4px solid rgba(var(--vs-primary), 1);
}
.blog-image-holder {
  width: 100%;
  height: 300px;
}
.blog-image-holder img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.divider {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.feedback-block {
  background: #eff3f4;
  border-radius: 8px;
  padding: 10px;
  position: relative;
}
.commented-section .feedback-block {
  max-width: 65%;
}
.commented-emoji {
  display: flex;
  position: absolute;
  right: -20px;
  bottom: 0;
}
.commented-emoji img {
  width: 18px;
}
.replied-section,
.reply-para {
  margin-left: 50px;
}
.reply-block {
  position: relative;
}
.sent-btn {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  height: 100%;
  padding: 0 15px;
  cursor: pointer;
}
.reply-block::after {
  content: "";
  width: 1px;
  height: 50%;
  background: rgba(0, 0, 0, 0.1);
  position: absolute;
  right: 54px;
  top: 50%;
  transform: translateY(-50%);
}
.reply-block .vs-textarea {
  height: 65px;
  padding-right: 60px;
}
.post-block .info_block {
  display: flex;
  align-items: center;
}
.post-block .info_block p {
  display: flex;
  align-items: center;
}
.post-block .info_block p:not(:last-child)::after {
  content: "";
  width: 2px;
  height: 15px;
  background: rgba(0, 0, 0, 0.2);
  display: inline-flex;
  margin: 0 10px;
}
.like-section {
  display: flex;
  justify-content: flex-end;
}
.like-section img,
.emoji-section img {
  width: 20px;
}
.post-share-modal table .person-img {
  width: 20px;
}
.post-share-modal .vs-table--thead {
  display: none;
}
.post-share-modal table tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.post-share-modal table td:first-child,
.post-share-modal table td:nth-child(2) {
  width: 10px;
}
.like-reaction {
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  z-index: 10;
  overflow: hidden;
}
.like-reaction img,
.like-reaction img.emoji {
  width: 24px;
}
.like-reaction:hover {
  overflow: unset;
}
.like-reaction:hover .emoji-section {
  transform: translateY(-70%);
  opacity: 1;
}
.emoji-section {
  display: flex;
  background: #fff;
  position: absolute;
  left: 0;
  border-radius: 30px;
  padding: 10px;
  box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.2);
  transform: translateY(-40%);
  opacity: 0;
  z-index: 1;
  transition: transform 0.5s ease;
}
.emoji-section img {
  margin: 2px;
}
.post-edit-modal.con-vs-popup .vs-popup {
  width: 60%;
}
.tox-tinymce-aux {
  z-index: 10000000000 !important;
}
.selected-names {
  background: #e5e4e8;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 5px;
  color: #0078d4;
  font-weight: 600;
  position: relative;
}
.selected-names img {
  width: 100%;
}
.selected-names .close {
  color: white;
  position: absolute;
  top: -8px;
  right: -7px;
  font-size: 25px;
  cursor: pointer;
  background: #0078d4;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.name-selected {
  white-space: nowrap;
  width: 75px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.blog-content img {
  width: 100%;
  object-fit: contain;
}
.blog-content iframe {
  height: 300px;
}
.emoticons-holder {
  position: relative;
  margin-left: -10px;
}
.emoticons-holder .emoticons-list {
  position: absolute;
  left: 0;
  top: 100%;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 10px;
  border-radius: 8px;
  z-index: 100;
  display: none;
}
.emoticons-holder:hover .emoticons-list {
  display: block;
}
@media (max-width: 991px) {
  .width-sm-100 {
    width: 100%;
  }
}
</style>